import { FIT_LABELS, KIDS_SIZES, availableSizesFor } from '../sizing';
import type { Fit, Product } from '../types';
import { useLanguage } from '../i18n';

type Props = {
  product: Product;
  fit: Fit;
  size: string;
  onChange: (fit: Fit, size: string) => void;
  priceLabel?: (size: string) => string;
};

export function FitAndSize({ product, fit, size, onChange, priceLabel }: Props) {
  const {language,t}=useLanguage();
  const label=(value:Fit)=>value==='hombre'?t('men'):value==='mujer'?t('women'):value==='nino'?t('kids'):FIT_LABELS[value];
  const options: Fit[] = product.kidsEnabled ? ['hombre', 'mujer', 'nino'] : ['hombre', 'mujer'];
  const sizes = availableSizesFor(product, fit);
  return <div className="fit-and-size">
    <div className="fit-options" role="group" aria-label="¿Para quién es la camiseta?">
      {options.map(option => <button key={option} type="button" className={fit === option ? 'selected' : ''}
        aria-pressed={fit === option} onClick={() => onChange(option, availableSizesFor(product, option)[0])}>
        {label(option)}
      </button>)}
    </div>
    {fit === 'sin_especificar' ? <p className="fit-hint">{t('selectFit',{kids:product.kidsEnabled?(language==='es'?' o Niño':' or Kids'):''})}</p> : <>
      <div className="sizes" role="group" aria-label={`Sizes ${label(fit)}`}>
        {sizes.map(value => <button key={value} type="button" className={size === value ? 'selected' : ''}
          aria-pressed={size === value} onClick={() => onChange(fit, value)}>
          {value}{priceLabel?.(value)}
        </button>)}
      </div>
      {fit === 'nino' && <details className="kids-guide"><summary>{t('sizeGuide')}</summary>
        <div className="kids-table-wrap"><table><thead><tr><th>{language==='es'?'Talla':'Size'}</th><th>{language==='es'?'Estatura':'Height'}</th><th>{language==='es'?'Edad aprox.':'Approx. age'}</th><th>{language==='es'?'Largo':'Length'}</th><th>{language==='es'?'Ancho':'Width'}</th><th>{language==='es'?'Cintura':'Waist'}</th></tr></thead>
          <tbody>{KIDS_SIZES.map(row => <tr key={row.size}><th>{row.size}</th><td>{row.height} cm</td><td>{row.age} {language==='es'?'años':'years'}</td><td>{row.length} cm</td><td>{row.width} cm</td><td>{row.waist} cm</td></tr>)}</tbody>
        </table></div><p>{language==='es'?'Las medidas pueden variar ligeramente. Si tienes dudas, escríbenos antes de pedir.':'Measurements may vary slightly. Contact us before ordering if you need help.'}</p>
      </details>}
    </>}
  </div>;
}
